module.exports = __webpack_public_path__ + "static/media/mainimg-04.e21b6134.png";